export default "__VITE_ASSET__BdPm9luS__"